export enum DialogCloseReason {
  BackdropClick = 'backdropClick',
  EscapeKeyDown = 'escapeKeyDown',
}
